import {
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { downloadInvoiceZip, getPrimeMemberInvoice } from "src/api/commonapi";
import Page from "src/components/Page";
import { IsNotValue } from "src/constant/variable";
import { notification } from "src/utils/messages";
import Select from "react-select";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { enGB } from "date-fns/locale";
import { saveAs } from "file-saver";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DownloadOutlined } from "@mui/icons-material";
import { Routes } from "src/constant/api_url";
import CustomLoader from "src/components/CustomLoader";

export default function DownloadInvoice() {
  const [page, setPage] = useState(1);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [invoiceData, setInvoiceData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [filtereddata, setFilteredData] = useState({
    member_source: -1,
    s_date: null,
    e_date: null,
    search: ""
  });

  const memberType = [
    { label: "All", value: -1 },
    { label: "Prime Member", value: 0 },
    { label: "Privilege Member", value: 1 }
  ];

  const handleGetInvoiceData = async (data) => {
    setIsLoading(true);

    const resp = await getPrimeMemberInvoice({
      start: page,
      limit: rowPerPage,
      ...data
    });
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setInvoiceData(resp?.data?.invoiceData);
      setTotalRows(resp?.data.counter);
    }
  };

  const handleDownloadInvoice = async (data) => {
    try {
      const fileUrl = `${Routes.API_HOSTNAME}invoice-pdf/${encodeURIComponent(
        `${data.pr_i_filename}`
      )}`;
      // Fetch the file as a blob
      const response = await fetch(fileUrl, { method: "GET" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Create an invisible <a> element to trigger download
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `${data.pr_i_filename}`); // Force download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {}
  };

  useEffect(() => {
    handleGetInvoiceData(filtereddata);
  }, [page, rowPerPage]);

  const columns = [
    { name: "No", selector: (row, index) => index + 1 + (page - 1) * rowPerPage, width: "70px" },
    {
      name: "Invoice No.",
      wrap: true,
      selector: (row) => row?.pr_invoice_no,
      sortable: true
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.m_name,
      sortable: true
    },
    {
      name: "Email",
      wrap: true,
      selector: (row) => (!IsNotValue.includes(row?.m_email_id) ? row?.m_email_id : ""),
      sortable: true
    },
    {
      name: "Mobile No.",
      wrap: true,
      selector: (row) => row?.mobile_no,
      sortable: true
    },
    {
      name: "Invoice Date",
      wrap: true,
      selector: (row) => row?.pr_invoice_date,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      width: "100px",
      cell: (row) => (
        <>
          <Tooltip title="Download Invoice">
            <IconButton
              onClick={() => {
                handleDownloadInvoice(row);
              }}
            >
              <DownloadOutlined color="secondary" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const handleDownloadInvoiceZip = async () => {
    setIsLoading(true);
    const resp = await downloadInvoiceZip({
      start: page,
      limit: rowPerPage,
      ...filtereddata
    });
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      saveAs(`${resp.data.zip_url}`, `${resp?.data?.file_name}`);
    }
  };

  return (
    <>
      <Page title="LVB Cancel Membership Subject | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Downloaded Invoice
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          <Card style={{ padding: "25px" }}>
            <Stack>
              <Grid container spacing={2} justifyContent="flex-end" alignItems="flex-end">
                <Grid item xs={12} sm={6} md={3}>
                  <Stack
                  // spacing={3}
                  // style={{ marginTop: "20px" }}
                  >
                    {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={enGB}
                      // style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        name="s_date"
                        label="Start Date "
                        inputFormat="dd/MM/yyyy"
                        value={
                          filtereddata.s_date
                            ? new Date(filtereddata.s_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                            : null
                        }
                        onChange={(newDate) => {
                          if (newDate instanceof Date && !isNaN(newDate)) {
                            const day = String(newDate.getDate()).padStart(2, "0");
                            const month = String(newDate.getMonth() + 1).padStart(2, "0");
                            const year = newDate.getFullYear();
                            setFilteredData({
                              ...filtereddata,
                              s_date: `${day}-${month}-${year}`
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Stack
                  //  spacing={3}
                  //  style={{ marginTop: "20px" }}
                  >
                    {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={enGB}
                      // style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        name="e_date"
                        label="End Date "
                        inputFormat="dd/MM/yyyy"
                        value={
                          filtereddata.e_date
                            ? new Date(filtereddata.e_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                            : null
                        }
                        onChange={(newDate) => {
                          if (newDate instanceof Date && !isNaN(newDate)) {
                            const day = String(newDate.getDate()).padStart(2, "0");
                            const month = String(newDate.getMonth() + 1).padStart(2, "0");
                            const year = newDate.getFullYear();
                            setFilteredData({
                              ...filtereddata,
                              e_date: `${day}-${month}-${year}`
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Stack

                  // spacing={3}
                  >
                    <label
                    // style={{ marginBottom: "10px" }}
                    >
                      Select Member Type
                    </label>
                    <Select
                      value={memberType.map((c) => {
                        if (c.value == filtereddata.member_source) {
                          return { value: c.value, label: c.label };
                        }
                      })}
                      menuPortalTarget={document.body}
                      onChange={(e) => {
                        setFilteredData({
                          ...filtereddata,
                          member_source: e.value
                        });
                      }}
                      options={memberType}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Stack
                  // spacing={3}
                  // style={{ marginTop: "20px" }}
                  >
                    {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                    <TextField
                      // style={{ marginTop: "0px" }}
                      size="small"
                      fullWidth
                      autoComplete="off"
                      label="Search..."
                      name="search"
                      value={filtereddata?.search}
                      onChange={(e) => {
                        setFilteredData({
                          ...filtereddata,
                          search: e.target.value
                        });
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs="auto">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around"
                    }}
                  >
                    <Button
                      style={{ marginRight: "15px" }}
                      onClick={() => {
                        handleGetInvoiceData(filtereddata);
                      }}
                      variant="contained"
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      search
                    </Button>
                    <Button
                      // style={{ marginTop: "15px" }}
                      onClick={async () => {
                        // await setLoadingMoreData(-1);
                        await setFilteredData({
                          member_source: -1,
                          s_date: null,
                          e_date: null,
                          search: ""
                        });
                        handleGetInvoiceData({
                          member_source: -1,
                          s_date: null,
                          e_date: null,
                          search: ""
                        });
                      }}
                      variant="contained"
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      clear
                    </Button>
                  </div>
                </Grid>
                <Grid item xs="auto">
                  <Button
                    // style={{ marginTop: "15px" }}
                    onClick={() => {
                      handleDownloadInvoiceZip();
                    }}
                    variant="contained"
                    disabled={isLoading}
                    startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                  >
                    Downloaded Invoice Zip
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Card>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
              columns={columns}
              data={invoiceData != null ? invoiceData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
